<template>
  <!--  <div :style="{'min-height': minHeight + 'px'}" id="myhead">-->
  <div style="height: 100vh" id="myhead">
    <div v-if="!$isiPad && minWidth > 500">
      <div class="notifyOuter">
        <i class="icon iconfont iconbangzhu colorYellowF36A20 f_w notifyer"></i>
        <div class="notifyContent">
          <span class="font12" style="color: #b1b1b1">对于本系统有任何疑问(操作/流程/权限等)，请联系</span>
          <br />
          <span class="font12" style="color:#ed610b;text-decoration: underline">Tech CEDL Team</span>
          <span style="color: #b1b1b1" class="font12">进行咨询</span>
        </div>
      </div>
      <div style="padding: 70px 0">
        <img src="../../../assets/logo.png" width="110" style="margin-left: 66px" />
      </div>
      <div style="height: calc(100vh - 200px)">
        <ul style="padding-bottom: 20px;width: 100%;height: calc(100% - 240px);overflow: auto">
          <li
            v-if="userMenu.indexOf(object.name) >= 0"
            :key="index"
            v-for="( object , index) in menuList"
            class="p_r"
          >
            <span
              :class="object.active.indexOf(fatherHtml) >= 0 && fatherHtml !== '' ? 'active' : '' "
              @click="toUrL(object)"
              class="p_r"
            >
              <i :class="object.iconName" style="font-size: 18px"></i>
              <span
                style="display: inline-block;width: 65%;vertical-align: baseline"
                class="font18 Newline colorGrayA7A7A7"
              >{{object.name}}</span>
              <!--              <abbr class="menuNumber" v-if="object.name === '内容发布管理'">99</abbr>-->
              <i
                v-if="object.children && object.children.length > 0"
                :style="{ 'transform':object.check ? 'rotate(0deg)' : 'rotate(90deg)' }"
                style="font-size: 14px;margin:0px;color:#B7B7B7;display: inline-block;transition: all 0.2s;vertical-align: baseline"
                class="icon iconfont iconliebiaoxiangzuojiantou"
              ></i>
            </span>
            <dl
              v-if="object.children && object.children.length > 0"
              :style="{ 'display':object.check ? 'none' : 'inline-block'}"
            >
              <dd
                v-if="!(childrenobject.url === 'myAllocatedTwo' && !AssistantNumber.isMainAssistant) && childrenobject.showMenu"
                :class="activeHtml === childrenobject.url ? 'active' : ''"
                :key="childIndex"
                v-for="(childrenobject , childIndex) in object.children"
                @click="toUrL(object, childIndex)"
                class="p_r"
              >
                <span v-html="childrenobject.name"></span>
                <abbr v-if="childrenobject.url === 'myReview'">{{FinanceTeamList.toBeReviewCount}}</abbr>
                <abbr
                  v-if="childrenobject.url === 'myAllocated'"
                >{{FinanceTeamList.alreadyAllocatedCount}}</abbr>
                <!--              我的待办（部门助理数量）-->
                <abbr
                  v-if="childrenobject.url === 'myPending'"
                >{{newAssistantNumber.totalToBeSubmittedCount}}</abbr>
                <abbr
                  v-if="childrenobject.url === 'myAllocatedTwo'"
                >{{newAssistantNumber.totalAlreadyAllocatedCount}}</abbr>
                <abbr v-if="childrenobject.url === 'myApprovalOne'">{{myReviewNumber}}</abbr>
                <abbr v-if="childrenobject.url === 'myApprovalTwo'">{{myFinanceDirector}}</abbr>
              </dd>
            </dl>
          </li>
        </ul>
        <div class="logDiv p_r">
          <img src="../../../assets/home02.png" width="100%" />
          <div class="p_r">
            <p>
              <i class="icon iconfont iconuser" style="font-size: 30px"></i>
            </p>
            <p class="font14 m_b_10 NoWrap">{{ gskloginInfo.userName }}</p>
          </div>
          <section class="p_a c_p" style="right: 5px;bottom: 5px;" @click="toQuit()" title="退出">
            <i class="icon iconfont iconexit colorWhite c_p" style="font-size: 20px"></i>
          </section>
        </div>
        <!-- <p style="white-space: normal;" class=" pd_10">
          <span style="color:#a6a6a6" class="font14 f_w">提示：</span><br/>
          <span class="font12" style="color: #b1b1b1">对于本系统有任何疑问(操作/流程/权限等)，请联系</span><span class="font12" style="color:#ed610b;text-decoration: underline">cf642885@gskconsumer.com</span><span style="color: #b1b1b1" class="font12">进行咨询</span>
        </p>-->
      </div>
    </div>
    <div v-else>
      <div style="width: calc(85% - 20px);margin:auto;padding: 5px 0">
        <img src="../../../assets/logo.png" width="100%" />
      </div>
      <ul
        style="padding: 15px;position: relative"
        :style="{'min-height': (minHeight - 200) + 'px'}"
      >
        <li v-if="object.showMenu" :key="index" v-for="( object , index) in menuList" class="p_r">
          <span
            :class="fatherHtml === object.father ? 'active' : ''"
            @click="toUrL(object)"
            style="padding: 10px"
          >
            <i :class="object.iconName" style="margin: 0 1px"></i>
          </span>
          <div class="ipadChild">
            <dl
              v-if="object.children && object.children.length > 0"
              :style="{ 'display':object.check ? 'none' : 'block','top':object.top,'left': object.left }"
            >
              <dd
                v-if="childrenobject.showMenu"
                :class="activeHtml === childrenobject.url ? 'active' : ''"
                :key="childIndex"
                v-for="( childrenobject , childIndex) in object.children"
                @click="toUrL(object, childIndex)"
                class="p_r"
              >
                <i></i>
                <span v-html="childrenobject.name"></span>
              </dd>
            </dl>
          </div>
        </li>
      </ul>
      <!--<abbr class="historyNumber" :style="{display:fatherHtml === 'MyTodo'?'none':'block'}">5</abbr>-->
    </div>
  </div>
</template>

<script>
let urlTime
export default {
  name: 'myhead',
  props: [
    'minHeight'
  ],
  data () {
    return {
      userMenu: this.$userMenu,
      gskloginInfo: JSON.parse(localStorage.gskloginInfo) || {},
      publish: process.env.config,
      myFinanceDirector: localStorage.myFinanceDirector,
      myReviewNumber: localStorage.myReviewNumber,
      showTip: true,
      todoLength: '',
      minWidth: '',
      activeHtml: '',
      fatherHtml: '',
      menuList: [
        {
          active: 'myHomemyErrorMessageListmyUpHistoryRecord',
          father: 'myHome',
          iconName: 'icon iconfont iconshangchuan colorGrayA7A7A7',
          showMenu: true,
          check: true,
          permissionName: '数据上传',
          name: '数据上传',
          children: []
        },
        {
          active: 'myDnloadmyDnloadHomemyDnloadHomeDetailmyOneSuCriberListmyAllSuCriberListmyOneDnloadTaskListmyAllDnloadTaskListmyDnloadHomeTwoDetail',
          father: 'myDnload',
          iconName: 'icon iconfont iconxiazai1 colorGrayA7A7A7',
          showMenu: true,
          check: true,
          permissionName: '数据下载',
          name: '数据下载',
          children: []
        },
        {
          active: 'mySystemListmyValidationDetailmySupersuPromySupersuProList',
          father: 'mySystemList',
          iconName: 'icon iconfont iconxitong-copy colorGrayA7A7A7',
          showMenu: true,
          check: true,
          permissionName: '系统管理',
          name: '系统管理',
          children: []
        }
      ],
      AssistantNumber: {},
      newAssistantNumber: {},
      FinanceTeamList: {}
    }
  },
  created () {
    // if (this.$userInfo) {
    //   for (let i = 0; i < this.$userInfo.length; i++) {
    //     for (let o = 0; o < this.menuList.length; o++) {
    //       if (this.$userInfo[i].moduleName === this.menuList[o].permissionName) {
    //         this.menuList[o].showMenu = true
    //       }
    //       if (this.$userInfo[i].childModules) {
    //         for (let j = 0; j < this.$userInfo[i].childModules.length; j++) {
    //           for (let k = 0; k < this.menuList[o].children.length; k++) {
    //             if (this.$userInfo[i].childModules[j].moduleName === this.menuList[o].children[k].permissionName) {
    //               this.menuList[o].children[k].showMenu = true
    //             }
    //           }
    //         }
    //       }
    //     }
    //   }
    // }
    this.changeSelUrl()
    // // this.getMypermission()
    // urlTime = setInterval(p => {
    //   if (window.localStorage.getItem('reflash') === 'true') {
    //     window.localStorage.setItem('reflash', 'false')
    //     this.changeSelUrl()
    //   }
    // }, 300)
  },
  destroyed () {
    clearInterval(urlTime)
  },
  mounted () {
    this.minWidth = window.screen.width
    // console.log(this.$isiPad)
    // this.myMinHeight = window.innerHeight - 10
    // if (this.minWidth < 1300) {
    //   this.myMinHeight = this.myMinHeight - 40
    // } else if (this.minWidth < 1400) {
    //   this.myMinHeight = this.myMinHeight - 30
    // }
    // Time = setInterval(p => {
    //   this.myMinHeight = window.innerHeight - 10
    //   if (this.minWidth < 1300) {
    //     this.myMinHeight = this.myMinHeight - 40
    //   } else if (this.minWidth < 1400) {
    //     this.myMinHeight = this.myMinHeight - 30
    //   }
    // }, 1000)
    setInterval(p => {
      let flag = window.localStorage.getItem('Assistant')
      if (flag === 'true') {
        this.getTodoSummaryInfo()
        window.localStorage.setItem('Assistant', 'false')
      }
      let flag2 = window.localStorage.getItem('FinanceTeam')
      if (flag2 === 'true') {
        this.getFinanceTeamTodoSummaryInfo()
        window.localStorage.setItem('FinanceTeam', 'false')
      }
    }, 100)
  },
  methods: { // 所有的方法封装
    getMypermission () {
      for (let i = 0; i < this.menuList.length; i++) {
        if (this.menuList[i].father) {
          if (this.$fatherMenuList.indexOf(this.menuList[i].father) >= 0) {
            this.menuList[i].showMenu = true
          }
        } else {
          for (let j = 0; j < this.menuList[i].children.length; j++) {
            if (this.$childMenuList.indexOf(this.menuList[i].children[j].url) >= 0) {
              this.menuList[i].showMenu = true
              this.menuList[i].children[j].showMenu = true
            }
          }
        }
      }
    },
    changeSelUrl () {
      if (this.$route.query.from !== '' && this.$route.query.from !== undefined) {
        this.fatherHtml = this.$route.query.from
      } else {
        this.fatherHtml = this.$route.name
      }
      // for (let i = 0; i < this.menuList.length; i++) {
      //   this.menuList[i].check = true
      //   if (this.menuList[i].father === this.activeHtml && this.menuList[i].children.length === 0) {
      //     this.fatherHtml = this.menuList[i].father
      //     return
      //   } else {
      //     this.fatherHtml = ''
      //   }
      //   for (let j = 0; j < this.menuList[i].children.length; j++) {
      //     if (this.menuList[i].children[j].url === this.activeHtml) {
      //       this.menuList[i].check = false
      //     }
      //   }
      // }
    },
    toUrL (object, index) {
      this.fatherHtml = object.father
      this.activeHtml = ''
      this.$router.push({
        name: object.father
      })
      // let flag = false
      // if (!object.check) {
      //   flag = true
      // }
      // for (let i = 0; i < this.menuList.length; i++) {
      //   this.menuList[i].check = true
      // }
      // if (index !== undefined) {
      //   // if (urlType === 'MyTodo') {
      //   //   this.showTip = false
      //   //   this.$router.push({
      //   //     name: urlType.father
      //   //   })
      //   // }
      //   if (!this.$isiPad) {
      //     object.check = false
      //   } else {
      //     object.check = true
      //   }
      //   this.activeHtml = object.children[index].url
      //   this.$router.push({
      //     name: object.children[index].url
      //   })
      // } else {
      //   if (object.children.length > 0) {
      //     this.fatherHtml = ''
      //     if (!flag) {
      //       object.check = false
      //     }
      //     // this.activeHtml = object.children[0].url
      //   } else {
      //     this.fatherHtml = object.father
      //     this.activeHtml = ''
      //     if (object.name === '系统管理') {
      //       if (this.userMenu.indexOf('系统管理') >= 0 && this.userMenu.indexOf('数据规则校验') < 0 && this.userMenu.indexOf('权限配置') < 0 && this.userMenu.indexOf('api Gate管理') < 0) {
      //         this.$router.push({
      //           name: 'mySystemMessager'
      //         })
      //       } else if (this.userMenu.indexOf('系统管理') >= 0 && this.userMenu.indexOf('数据规则校验') >= 0) {
      //         this.$router.push({
      //           name: 'mySystemList'
      //         })
      //       } else if (this.userMenu.indexOf('系统管理') >= 0 && this.userMenu.indexOf('权限配置') >= 0) {
      //         this.$router.push({
      //           name: 'mySupersuProList'
      //         })
      //       } else if (this.userMenu.indexOf('系统管理') >= 0 && this.userMenu.indexOf('api Gate管理') >= 0) {
      //         this.$router.push({
      //           name: 'myAPIGateList'
      //         })
      //       }
      //     } else {
      //       this.$router.push({
      //         name: object.father
      //       })
      //     }
      //   }
      // }
    },
    async toQuit () {
      let res = await this.$commonJs.addLog('退出', '', '', '')
      if (res) {
        window.localStorage.removeItem('gskToken')
        window.localStorage.removeItem('gskloginInfo')
        window.location.href = this.publish.loginOutUrl
      }
    }
  }
}
</script>

<style scoped>
#myhead {
  /*margin-bottom: 50%;*/
}
#myhead li {
  margin: 10px 0;
}
#myhead li > span {
  display: inline-flex;
  justify-content: flex-end;
  align-items: center;
  width: calc(90% - 70px);
  border-radius: 0 100px 100px 0;
  padding: 10px 40px 10px 35px;
  margin: 0;
  cursor: pointer;
  white-space: nowrap;
  word-break: break-all;
  font-size: 14px;
}
#myhead li > span i {
  margin: 0 10px;
  font-size: 24px;
  /*margin-right: 10px;*/
}
#myhead li > span.active {
  /*background: linear-gradient(to right, #C73343 , #E25D72);*/
  background-color: #ffffff;
  box-shadow: 1px 2px 5px rgba(243, 106, 32, 0.25);
  font-weight: bold;
}
#myhead li > span.active i {
  color: #f36a20 !important;
}
#myhead li > span.active span {
  color: black !important;
}
#myhead li > span i {
  /*color: #C73343;*/
}
#myhead li > span span {
  /*color: #333;*/
  /*font-weight: bold;*/
}
#myhead li dl {
  width: 100%;
  /*margin-top: -10px;*/
  /*max-width: 200px;*/
  /*width: 300%;*/
}
#myhead li dl dd {
  padding: 10px 0px 10px 74px;
  /*background: #28292B;*/
  text-align: left;
  margin: 5px 0;
}
#myhead li dl dd > span {
  display: inline-block;
  vertical-align: middle;
  white-space: normal;
  word-break: break-word;
  width: 60%;
  font-size: 14px;
}
#myhead li dl dd > abbr {
  display: inline-block;
  background-color: white;
  width: 24px;
  line-height: 24px;
  border-radius: 50%;
  color: #c73343;
  text-align: center;
  /*position: absolute;*/
  /*top: 6px;*/
  /*right: 40px;*/
}
.menuNumber {
  display: inline-block;
  background-color: #e65d66;
  width: 24px;
  line-height: 24px;
  border-radius: 50%;
  color: #fef9f9;
  text-align: center;
  position: absolute;
  top: 8px;
  right: 66px;
}
#myhead li dl dd.active {
  background-color: #f4f7fc;
}
#myhead li dl dd.active span {
  color: #5765d0;
  font-weight: bold;
}
#myhead li a {
  display: block;
}
.historyNumber {
  display: inline-block;
  background-color: white;
  width: 20px;
  line-height: 20px;
  border-radius: 50%;
  color: #c73343;
  text-align: center;
  position: absolute;
  top: 18px;
  right: 45px;
}
.ipadChild {
  position: absolute;
  /*left: 18px;*/
  /*top: 100px;*/
}
.ipadChild dl {
  position: relative;
  margin: 0 !important;
  border-radius: 5px;
  background-color: #c7133f;
  padding: 5px;
}
.ipadChild dl dd {
  padding: 5px !important;
  margin: 0 !important;
}
.ipadChild dl dd > span {
  width: auto !important;
}
.notifyOuter {
  position: relative;
}
.notifyer {
  font-size: 20px;
  position: absolute;
  top: 10px;
  right: 10px;
}
.notifyer:hover + .notifyContent {
  display: block;
}
.notifyContent {
  display: none;
  position: absolute;
  border: 1px solid rgba(0, 0, 0, 0.15);
  background: #fff;
  left: 2px;
  top: 34px;
  padding: 8px 6px;
}
.logDiv {
  width: 54%;
  margin: auto;
  position: relative;
  border-radius: 16px;
}
.logDiv > img {
  border-radius: 16px;
}
.logDiv > div {
  background: linear-gradient(
    321.68deg,
    rgba(217, 38, 0, 0.9) 6.58%,
    rgba(249, 162, 7, 0.9) 64.25%
  );
  border-radius: 16px;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  text-align: center;
  color: white;
}
.logDiv > div > p {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/left-menu/menu.vue